/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { connect } from 'react-redux';

import api from 'api';

import LoginPasswordPresenter from './LoginPassword.presenter';

import routeNames from 'lib/routeNames';
import userActions from 'redux/actions/user';
import navigationActions from 'redux/actions/navigation';
import sessionActions from 'redux/actions/session';
import groupSelectors from 'redux/reduxStore/group';
import userSelectors from 'redux/reduxStore/user';
import { accessTokenTypes } from 'models/AccessTokenModel';

function mapStateToProps(state) {
  const group = groupSelectors.getActiveGroup(state) || {};

  return {
    email: userSelectors.getEmail(state),
    groupId: group.id || -1,
    groupName: group.name || '',
    organizationName: group.organization_name || '',
  };
}

function mapDispatchToProps(dispatch) {
  return {
    goBack: () => {
      dispatch(navigationActions.goBackTo(routeNames.loginEmail()));
    },
    loginSuccessful: (accessToken) => {
      dispatch(sessionActions.loginSuccessful(accessToken));
      dispatch(navigationActions.replace(routeNames.home()));
    },
    updateUser: (user) => {
      dispatch(userActions.receive(user));
    },
  }
}

class LoginPassword extends React.Component {

  constructor(props) {
    super(props);

    this.submitCredentials = this.submitCredentials.bind(this);

    this.state = {
      requiresMfa: false,
    };
  }

  submitCredentials(credentials) {
    const groupCredentials = _.assign({}, credentials, {
      groupId: this.props.groupId,
    });
    return api.sessionApi.login(groupCredentials)
    .then((sessionToken) => {
      const requiresMfa = sessionToken.type === accessTokenTypes.MFA;
      if (requiresMfa) {
        this.setState({ requiresMfa });
      } else {
        this.props.loginSuccessful(sessionToken);
      }
    }).catch((apiError) => {
      this.setState({ errorPhraseId: apiError.messageKey() });
    });
  }

  render() {
    return (
      <LoginPasswordPresenter
        submitCredentials={this.submitCredentials}
        requiresMfa={this.state.requiresMfa}
        errorPhraseId={this.state.errorPhraseId}
        clearErrorMessage={() => { this.setState({ errorPhraseId: '' }) }}
        goBack={this.props.goBack}
        email={this.props.email}
        groupName={this.props.groupName}
        organizationName={this.props.organizationName}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPassword);
